// extracted by mini-css-extract-plugin
module.exports = {"bread":"Bread_bread-3y-rA"};